// extracted by mini-css-extract-plugin
export default {"text":"disclaimer_text__EvP2z","link":"disclaimer_link__cOHwC"};